import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Btns,
  ButtonL,
  Content,
  ImgWrap,
  Section,
  TextDiv,
} from "../../styles/Common";
import needLoginImg from "../../styles/images/img_need_login.png";
import { styled } from "styled-components";
import OnlyHeaderLayout from "../../components/layout/OnlyHeaderLayout";
import { returnLoginStatus } from "../../components/hooks/authFunc";
const NeedLogin = () => {
  const location = useLocation();
  let navigate = useNavigate();
  const isLogin = returnLoginStatus();
  useEffect(() => {
    if (isLogin) navigate(-1);
  }, []);
  return (
    <OnlyHeaderLayout>
      <Section className="minPaddingTop">
        <Content>
          <NeedLoginTextDiv>
            <h3>
              회원서비스 이용을 위해{" "}
              <span onClick={() => navigate("/login")}>로그인</span> 해주세요!
            </h3>
            <p>로그인 하고 뮤포인트의 다양한 혜택을 누리세요.</p>
          </NeedLoginTextDiv>
          <NeedLoginImgWrap margintop="5.2" imgwidth="27.5">
            <img src={needLoginImg} alt="" />
          </NeedLoginImgWrap>
        </Content>
        <Btns>
          <ButtonL
            onClick={() => {
              navigate("/login");
            }}
          >
            로그인
          </ButtonL>
        </Btns>
      </Section>
    </OnlyHeaderLayout>
  );
};

export default NeedLogin;
const NeedLoginTextDiv = styled(TextDiv)`
  span {
    text-decoration: underline;
  }
  p {
    margin-top: 1rem;
  }
`;
const NeedLoginImgWrap = styled(ImgWrap)`
  text-align: right;
  @media screen and (min-width: 400px) {
    text-align: center;
  }
`;
